export const environment = {
  production: true,
  apiUrl: 'https://api.soluzionemedicolegale.it/api'
};

